import React, { useState, useEffect } from 'react';
import api from './../../api/api';
import { Link } from 'react-router-dom';
import Msg from './../../util/msg';

const ClienteLista = () => {
    const [clientes, setClientes] = useState([]);
    const [filtro, setFiltro] = useState("");

    const carregaClientes = async () => {
        const response = await api.get('clientes.php?search=' + filtro);
        return response.data.data;
    }

    const handleInput = (e) => {
        setFiltro(e.target.value);
    }

    const handleExcluir = (id) => {
        Msg.confirm("Deseja excluir este cliente?", () => {
            api.delete('cliente_excluir.php?id=' + id).then(() => {
                return carregaClientes();
            }).then((clientes) => {
                setClientes(clientes);
            });
        });

        
    }
    
    useEffect(() => {
        const getClientes = async () => {
            const todosClientes = await carregaClientes();
            if (todosClientes) setClientes(todosClientes);
        }
        getClientes();
    }, [filtro])

    return (
        <>
            <div className='mt-2 mb-2'>
                <Link to="/clientes/novo" className='btn btn-success'>Novo Cliente</Link>
                <div class="input-group mt-3 mb-3">
                    <input type="text" className="form-control" value={filtro} onChange={handleInput} placeholder='Pesquisa'/>
                </div>

            </div>
            <div className='table-responsive'>
                <table className='table table-striped'>
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Whatsapp</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {clientes.map(cli => (
                            <tr key={cli.id}>
                                <td>{cli.nome}</td>
                                <td>{cli.whatsapp}</td>
                                <td>
                                    <Link to={"/clientes/" + cli.id} 
                                        className="btn btn-sm btn-primary me-1">Editar</Link>
                                    <button  onClick={() => handleExcluir(cli.id)}
                                        className='btn btn-sm btn-danger'>Excluir</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    )

}

export default ClienteLista;